










import Vue from 'vue';

export default Vue.extend({
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    left: {
      type: Boolean,
      default: false,
    },
    onSide: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    arrowPositionClass() {
      const position = this.onSide ? 'side' : 'up';
      const direction = this.left ? 'left' : 'right';
      return {
        position: `tooltip__content--arrow-${position}`,
        direction: `tooltip__content--arrow-${position}-${direction}`,
      };
    },
  },
});
